<script>
    import { t, locale } from "$lib/translations";
    import DonateImage from "$lib/images/donate.webp";
    import UserIcon from "$lib/images/user.svg";
    import EmailIcon from "$lib/images/email.svg";
    import WalletIcon from "$lib/images/wallet-dark.svg";
    import LogoIcon from "$lib/images/logo.svg";
    import axiosInstance from "$lib/js/axios.js";
    import { options } from "/src/config/servers.js";
    import { error, json } from "@sveltejs/kit";
    import { onMount } from "svelte";
    import selectServerImage from "$lib/images/select-server.svg";
    import arrowImage from "$lib/images/arrow.svg";

    let amount;

    onMount(() => {
        if (selected) {
            amount = selected.min;
        } else {
            amount = 0;
        }
    });

    function handleInputAmount(event) {
        let inputValue = event.target.value;

        if (inputValue.startsWith("0") && inputValue.length > 1) {
            inputValue = inputValue.substring(1);
        }

        if (parseFloat(inputValue) > 999999) {
            inputValue = "999999";
        }

        amount = inputValue === "" ? 0 : parseFloat(inputValue);
        event.target.value = inputValue;
    }

    let login;
    let email;
    let user_agreement = true;

    let login_error = false;
    let login_error_str = "";

    let email_error = false;
    let amount_error = false;
    let user_agreement_error = false;
    let error_response = "";

    const checkboxStatus = () => {
        if (!user_agreement) {
            user_agreement_error = true;
            return;
        }
        user_agreement_error = false;
    };

    const createDonate = async () => {
        if (amount < (selected ? selected.min : 0) || amount > 999999) {
            amount_error = $t("donate.errors_amount");
            return;
        }
        if (email.value && !email.value.includes("@")) {
            email_error = $t("donate.errors_email");
            return;
        }
        if (!user_agreement) {
            user_agreement_error = true;
            return;
        }

        try {
            const formData = new FormData();
            formData.append("login", login.value);
            formData.append("email", email.value);
            formData.append("amount", amount);
            formData.append("lang", $locale);
            formData.append("server", selected.value);
            formData.append("amount_with_bonus", calculatedAmount);

            const response = await axiosInstance.post("/donate/transaction/create/", formData);
            if (response.data.status) {
                return (window.location.href = response.data.response);
            } else {
                if (response.data.status_code === 404) {
                    login_error = true;
                    login_error_str = response.data.detail;
                    return;
                }
                error_response = response.data.detail;
            }
        } catch (error) {
            console.error(error);
        }
    };

    let isOpen = false;
    let selected;

    function selectOption(option) {
        selected = option;
        isOpen = false;
        calculatedAmount;
    }

    $: selected = $locale === "ua" || $locale === "ge" ? options.find(option => option.lang === $locale) : null;

    $: calculatedBonus = (() => {
        if (!selected) return;
        if (!selected.bonuses || selected.bonuses.length === 0) return 0;
        if (amount < selected.bonuses[0].amount) return 0;
        if (amount < selected.bonuses[1].amount) return (amount / 100) * selected.bonuses[0].percent * selected.ratio;
        if (amount < selected.bonuses[2].amount) return (amount / 100) * selected.bonuses[1].percent * selected.ratio;
        if (amount < selected.bonuses[3].amount) return (amount / 100) * selected.bonuses[2].percent * selected.ratio;
        if (amount < selected.bonuses[4].amount) return (amount / 100) * selected.bonuses[3].percent * selected.ratio;
        if (amount >= selected.bonuses[4].amount) return (amount / 100) * selected.bonuses[4].percent * selected.ratio;
        return 0;
    })();

    $: calculatedAmount = (() => {
        if (!selected) return 0;
        const bonusActive = selected.isBonus;
        const multiplier = selected.donateMultiplayer || 1;

        if (bonusActive && multiplier > 1) {
            return Math.floor(amount * selected.ratio * multiplier + calculatedBonus);
        } else if (bonusActive) {
            return Math.floor(calculatedBonus + amount * selected.ratio);
        } else if (multiplier > 1) {
            return Math.floor(amount * selected.ratio * multiplier);
        } else {
            return Math.floor(amount * selected.ratio);
        }
    })();
</script>

<section>
    <div class="donate-section">
        <div class="donate-form">
            <div class="text">
                <div style="display: flex; align-items: center; justify-content: space-between">
                    <h1 class="title">
                        {$t("donate.title")}
                    </h1>
                    {#if selected?.donateMultiplayer > 1}
                        <h2 class="yellow">x{selected.donateMultiplayer}</h2>
                    {/if}
                </div>

                <p class="description">
                    {$t("donate.description")}
                </p>
            </div>
            <form
                on:submit|preventDefault={createDonate}
                on:change={() => {
                    checkboxStatus(user_agreement, user_agreement_error);
                    login_error = false;
                    error_response = "";
                }}
            >
                <div class="inputs">
                    <label class="input" class:error={login_error}>
                        <div class="icon"><img src={UserIcon} alt="Login" /></div>
                        <input
                            type="text"
                            name="login"
                            id="login"
                            autocomplete="on"
                            bind:this={login}
                            placeholder={$t("donate.input_login_placeholder")}
                            required
                        />
                    </label>
                    {#if login_error}
                        <span class="span-error">{login_error_str}</span>
                    {/if}

                    <label class="input" class:error={email_error}>
                        <div class="icon"><img src={EmailIcon} alt="Email" /></div>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            autocomplete="on"
                            bind:this={email}
                            placeholder={$t("donate.input_email_placeholder")}
                            required
                        />
                    </label>
                    {#if email_error}
                        <span class="span-error">{$t("donate.errors_email")}</span>
                    {/if}

                    <div class="input" style="position:relative;">
                        <div
                            class="selected {selected
                                ? selected.label === $t('donate.select_server')
                                    ? 'placeholder'
                                    : 'active'
                                : 'placeholder'}"
                            on:click={() => (isOpen = !isOpen)}
                            tabindex="0"
                        >
                            <div style="display: flex; align-items: center; gap: 13px">
                                <img class="dropdown-img" src={selectServerImage} alt="icon" />
                                <span
                                    >{selected
                                        ? selected.label
                                            ? selected.label
                                            : $t("donate.select_server")
                                        : $t("donate.select_server")}</span
                                >
                            </div>
                            <img class="arrow-img {isOpen ? 'rotate' : ''}" src={arrowImage} alt="arrow" />
                        </div>
                        <ul class="dropdown-options {isOpen ? 'open' : ''}">
                            {#each options as option}
                                <li class="option" on:click={() => selectOption(option)}>
                                    <span>{option.label}</span>
                                </li>
                            {/each}
                        </ul>
                    </div>

                    <label class="input" style="padding-right: 11px;" class:error={amount_error}>
                        <div class="icon"><img src={WalletIcon} alt="Wallet" /></div>
                        <input
                            type="number"
                            name="amount"
                            id="amount"
                            autocomplete="off"
                            placeholder={$t("donate.input_amount_placeholder")}
                            min={selected ? selected.min : 0}
                            max="999999"
                            bind:value={amount}
                            on:input={handleInputAmount}
                            required
                        />
                        <div class="exchange">
                            = <span class="yellow">{calculatedAmount}</span>
                            <div class="icon"><img src={LogoIcon} alt="Logo" /></div>
                        </div>
                    </label>
                    {#if amount_error}
                        <span class="span-error">{$t("donate.errors_amount")}</span>
                    {/if}
                </div>

                {#if selected?.isBonus}
                    <div class="bonus-main">
                        {#each Object.entries(selected.bonuses) as bonus}
                            <div class="bonus-wrapper">
                                <div class="bonus">+{bonus[1].percent}%</div>
                                <p>
                                    {$t("donate.bonus")}
                                    {bonus[1].amount.toLocaleString("ru-RU")}
                                    {selected.currency}
                                </p>
                            </div>
                        {/each}
                    </div>
                {/if}

                <div class="checkbox">
                    <label class="custom-checkbox" for="user_agreement">
                        <input
                            type="checkbox"
                            name="user_agreement"
                            id="user_agreement"
                            bind:checked={user_agreement}
                        />
                        <span class="checkmark"></span>
                    </label>
                    <p>
                        {$t("donate.checkbox_label1")}
                        <a href="/{$locale}/user-agreement">{$t("donate.checkbox_label2")}</a>
                    </p>
                </div>
                {#if user_agreement_error}
                    <span class="span-error">{$t("donate.errors_agreement")}</span>
                {/if}

                <span class="span-error">{error_response}</span>

                <div class="payment-button">
                    <button class="btn btn-primary">{$t("donate.button_text")}</button>
                </div>
            </form>
        </div>
        <div class="image">
            <img src={DonateImage} alt="Donate" />
        </div>
    </div>
</section>

<style lang="scss">
    @import "/src/lib/scss/main";

    .span-error {
        color: red;

        &:empty {
            display: none;
        }
    }

    section {
        padding: 0 100px;
        margin-top: 100px;
        margin-bottom: 80px;
    }

    .donate-section {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
    }

    .donate-form {
        width: 475px;
        display: flex;
        flex-direction: column;
        gap: 25px;

        & > .text {
            display: flex;
            flex-direction: column;
            gap: 25px;

            .title {
                font-size: 45px;
                line-height: 93%;
                color: #fff;
                text-transform: uppercase;
                font-weight: 900;
                font-style: italic;
            }

            h2 {
                font-size: 45pt;
                font-weight: 900;
                font-style: italic;
                color: #fed500;
            }

            & > .description {
                color: #fff;
                opacity: 0.4;
                font-weight: 300;
            }
        }

        & > form {
            display: flex;
            flex-direction: column;
            gap: 25px;

            & > .inputs {
                display: flex;
                flex-direction: column;
                gap: 10px;

                & > .error {
                    border: 0.5px solid #9f0b0b !important;
                }

                .dropdown-img {
                    width: 24px;
                    height: 24px;
                }

                .arrow-img {
                    width: 12px;
                    height: 17px;
                    transition: transform 0.3s ease;

                    &.rotate {
                        transform: rotate(-180deg);
                    }
                }

                .dropdown-options {
                    position: absolute;
                    list-style: none;
                    width: 100%;
                    top: 100%;
                    max-height: 0;
                    overflow: hidden;
                    border: 0.5px solid rgba(255, 255, 255, 0.25);
                    transition:
                        border $default-transition-time,
                        max-height 0.6s ease,
                        opacity 0.6s ease,
                        visibility 0.6s ease;
                    border-radius: 7px;
                    backdrop-filter: blur(5px);
                    background: rgba(19, 19, 19, 0.7);
                    padding: 20px;
                    color: #ffffff;
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    opacity: 0;
                    visibility: hidden;
                    z-index: 2;

                    &.open {
                        max-height: 1000px;
                        opacity: 1;
                        visibility: inherit;
                    }

                    span {
                        transition: color 0.2s;

                        &:hover {
                            color: #fed500;
                        }
                    }
                }
            }

            & > .payment-button {
                width: 100%;
                height: 64px;

                & > button {
                    font-size: 18px;
                    line-height: 140%;
                    text-transform: uppercase;
                    color: #232323;
                    font-weight: 900;
                    font-style: italic;
                }
            }

            .bonus-main {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                row-gap: 10px;
            }

            .bonus-wrapper {
                display: flex;
                align-items: center;

                .bonus {
                    border-radius: 10px;
                    width: 47px;
                    height: 25px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-weight: 900;
                    font-style: italic;
                    font-size: 9pt;
                    color: #0f0f0f;
                    background: #fed500;
                    margin-right: 10px;
                }

                p {
                    font-weight: normal;
                    font-style: normal;
                    font-size: 9pt;
                    color: #fffbef;
                }
            }

            & > .checkbox {
                color: #fffbef;

                p {
                    font-size: 11pt;
                    line-height: 140%;
                    font-weight: 400;
                    color: rgba(255, 255, 255, 0.4);

                    a {
                        font-weight: 500;
                        text-decoration: underline;
                        text-decoration-skip-ink: none;
                        color: #fffbef;
                    }
                }
            }
        }
    }

    .image {
        //width: 30rem;
    }

    @media screen and (max-width: 1300px) {
        .image {
            width: 25rem !important;
        }
        section {
            padding: 0 30px !important;
        }
    }

    @media screen and (max-width: 1100px) {
        .image {
            display: none !important;
        }
        .donate-section {
            justify-content: center !important;
        }
    }

    @media screen and (max-width: 580px) {
        .donate-form {
            width: 400px !important;
        }
        .title {
            font-size: 40px !important;
        }
        h2 {
            font-size: 30pt !important;
        }
        .description {
            font-size: 14px;
        }
        .payment-button {
            height: 50px !important;

            & > button {
                font-size: 17px !important;
            }
        }

        .bonus-main {
            grid-template-columns: repeat(2, 1fr) !important;
        }
    }

    @media screen and (max-width: 450px) {
        .donate-form {
            width: 300px !important;
        }
        .title {
            font-size: 28px !important;
        }

        h2 {
            font-size: 25pt !important;
        }
    }
</style>
